export const flagshipUrl =
  process.env.APP_ENV === 'prod'
    ? 'https://biz-setting.moneyforward.com/mail'
    : 'https://biz-setting.test.mfw.work/mail';

export const formId = 'payment-request-setting-form';
